export default __webpack_public_path__ + "images/logoEmbryolisse.c165f9cb5358f5377e7f9c4f11ab3803.svg"